module.exports = __webpack_public_path__ + "img/ToniDunbar.add5aaaa.jpg";